import restApiConnection from '@/services/api/providers/Connection'
import RestApiBase from '@/services/models/RestApiBase'
import workloadUnitType from '@/types/responses/workloadUnit'
import { AxiosResponse } from 'axios'
import UserSession from '@/services/models/UserSession'

export default class SelfWorkload extends RestApiBase {
  public static async get(
    vehicleId?: number
  ): Promise<AxiosResponse<workloadUnitType>> {
    return this.sync('GetWorkloadUnits_' + (vehicleId ?? ''), this.getOwn, {
      vehicleId,
    })
  }

  public static getOwn = async (args: {
    vehicleId?: number
  }): Promise<AxiosResponse<workloadUnitType>> => {
    const user_id = UserSession.getStoredUserId() ?? ''
    return restApiConnection.get('/workload_units', {
      params: {
        user_session_id: user_id,
        limit: 15,
        vehicle_id: args.vehicleId,
      },
      headers: {
        'Cache-Control': 'max-age=0',
      },
    })
  }
}
